module.exports = __webpack_public_path__ + "img/Phoenix.3a00d3be.png";